import { Link } from 'react-router-dom';

interface CategoryCardProps {
  category: {
    slug: string;
    name: string;
    description: string;
    icon: string;
  };
}

export default function CategoryCard({ category }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${category.slug}`}
      className="bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-accent-300 transition-all group cursor-pointer"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0 group-hover:bg-accent-200 transition-colors">
          <i className={`${category.icon} text-accent-600 text-lg`}></i>
        </div>
        <div className="min-w-0">
          <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-1">
            {category.name}
          </h3>
          <p className="text-xs text-foreground-500 leading-relaxed">
            {category.description}
          </p>
        </div>
        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-300 group-hover:text-accent-500 transition-colors">
          <i className="ri-arrow-right-line text-sm"></i>
        </div>
      </div>
    </Link>
  );
}